"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Checkbox = _interopRequireDefault(require("../../Checkbox/Checkbox"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Cell formater: it's used in columns
// Receives the table instance and cell model as props
// https://react-table.tanstack.com/docs/api/useTable#column-options
var CellWithCheckbox = function CellWithCheckbox(_ref) {
  var value = _ref.value,
      index = _ref.row.index,
      id = _ref.column.id,
      updateData = _ref.updateData,
      className = _ref.className,
      onChange = _ref.onChange;
  var handleCheck = (0, _react.useCallback)(function (e) {
    updateData(index, id, _objectSpread(_objectSpread({}, value), {}, {
      checked: e.target.checked
    }));
    onChange(e);
  }, [id, index, onChange, updateData, value]);
  return (0, _jsxRuntime.jsx)(_Checkbox["default"], {
    id: value.id,
    value: value.value,
    onChange: handleCheck,
    checked: !!value.checked,
    className: className,
    truncate: true,
    children: value.label
  });
};

CellWithCheckbox.propTypes = {
  /**
   * The cell data
   */
  value: (0, _propTypes.shape)({
    id: _propTypes.string,
    value: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    label: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
  }).isRequired,
  row: (0, _propTypes.shape)({
    index: _propTypes.number
  }).isRequired,
  column: (0, _propTypes.shape)({
    id: _propTypes.string
  }).isRequired,

  /**
   * Custom function from Table for updating data
   */
  updateData: _propTypes.func,
  className: _propTypes.string,
  onChange: _propTypes.func
};
CellWithCheckbox.defaultProps = {
  updateData: function updateData() {},
  className: undefined,
  onChange: function onChange() {}
};
var _default = CellWithCheckbox;
exports["default"] = _default;
//# sourceMappingURL=CellWithCheckbox.js.map